/**
 * LinkedIn Conversions API tracking utility
 * Calls server-side endpoint to track conversions (avoids CORS issues)
 */

/**
 * Track CTA click for B2B page via server-side API
 * @param {string} ctaLocation - Where the CTA was clicked (hero, sticky, doors, etc.)
 */
export const trackB2BCtaClick = async (ctaLocation = 'unknown') => {
  try {
    await fetch('/api/track-linkedin-lead', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ctaLocation,
        userAgent: navigator.userAgent,
        pageUrl: window.location.href
      })
    });
  } catch (error) {
    // Fail silently - don't break user experience for tracking
    console.warn('LinkedIn tracking error:', error.message);
  }
};
